import AgroTechnicalEventsWrapper from '@/features/agro-technical-events/components/AgroTechnicalEventsWrapper';

export default function AgroTechnicalEventsPage() {
  return (
    <div className="flex">
      <AgroTechnicalEventsWrapper />
    </div>
  );
}
